import css from './style.module.scss';
import classNames from "classnames";
import {FC} from "react";
import {getPrizeAmount, getPrizeName} from "../wheel/logic";

type Props = {
    status: "start" | "result" | "success" | "fail",
    sum: number,
    prize?: number
}

const Header: FC<Props> = ({
    status,
    sum,
    prize,
}) => {

    const amount = formatAmount(sum);

    const classes = classNames({
        [css.header]: true,
        [css.result]: status === "result",
    });

    const insured = "You're covered with a health insurance!\nYou can keep your savings intact.";

    let isInsured = false, isPrize = false;
    let text: string, prizeAmountText: string = '';
    let prizeAmount: number;

    switch (status) {
        case "start":
            text = "Here's 1 Million pesos\nfor you!";
            break;
        case "result":
            text = getPrizeName(prize ?? 0);
            prizeAmount = getPrizeAmount(prize ?? 0);
            isPrize = true;
            isInsured = prizeAmount === 0;
            prizeAmountText = formatAmount(prizeAmount);
            break;
        case "success":
            text = "You did well!";
            break;
        case "fail":
            text = "Oh no!";
            break;
    }


    return (
        <div className={classes}>
            {
                isPrize ? (
                    isInsured ? (
                        <div className={css.textInsured}>{insured}</div>
                    )
                    : (
                        <>
                            <div className={css.textPrize}>{text}</div>
                            <div className={css.textAmount}>may cost you Php {prizeAmountText}</div>
                        </>
                    )
                )
                : (
                    <div className={css.text}>{text}</div>
                )
            }
            <div className={css.amountBlock}>
                <div className={css.amount}>Php {amount}</div>
                <div className={css.subtext}>YOUR SAVINGS</div>
            </div>
        </div>
    )
}

function formatAmount(amount: number) {
    const n = 0, x = 3;
    const re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\.' : '$') + ')';
    return amount.toFixed(Math.max(0, ~~n)).replace(new RegExp(re, 'g'), '$&,');
}

export default Header;